import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { authInterceptor } from './app/core/Intercaptors/auth.interceptor';
import { apmApiTrackingInterceptor } from './app/core/Intercaptors/apm-api-tracking.interceptor';

const httpInterceptorConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor, apmApiTrackingInterceptor])
    ),
  ],
};

bootstrapApplication(
  AppComponent,
  mergeApplicationConfig(appConfig, httpInterceptorConfig)
)
  .catch((err) => console.error(err));
